import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as uuid from "uuid";
import { AlertService } from "../../../providers/alert.service";
import { SigninService } from "../../../services/signin.service";
@Component({
    templateUrl: 'slideBlock.html',
    selector: 'slide-block-common',
    providers: [SigninService]
})
export class slideBlockCommon {

    imageObj: ImageModel = new ImageModel();
    public height: number = 0;
    public left: number = 0;
    canSilde = false;
    slide: any;
    originalX;
    userName: string = null;
    rectText: string = '拖动左边滑块完成上方拼图';
    loading: boolean = false;
    authSuccess: boolean = false;
    formType: string = 'login';
    originalImg: SafeResourceUrl = '#';
    slideImg: SafeResourceUrl = '#';
    catchId = uuid();

    constructor(
        private navPar: NavParams,
        private alert: AlertService,
        private sanitizer: DomSanitizer,
        private viewCtrl: ViewController,
        private signinService: SigninService
    ) {
        this.imageObj = new ImageModel();
        this.userName = this.navPar.get("userName") || null;
        this.formType = this.navPar.get("formType");
    }

    ionViewWillEnter() {
    }

    ionViewDidLoad() {
        this.getSecurityCode()
        this.authSuccess = false;
        // if (this.formType === 'regist') {
        //     this.getSecurityCode();
        // } else {
        //     this.needSecurityCode();
        // }
        let that = this;
        this.slide = document.getElementById('check-slide');
        this.slide.addEventListener("touchstart", function (ev) {
            ev.preventDefault();
            that.down(ev);
        }, false);
        document.body.addEventListener("touchmove", function (ev) {
            ev.preventDefault();
            that.move(ev);
        }, false);
        this.slide.addEventListener("touchend", function (ev) {
            ev.preventDefault();
            if (ev.target.id === 'check-slide' && !that.authSuccess) {
                that.authSecurityCode(that.left);
            }
        }, false);
    }

    /**
     * 验证是否成功
     * @param width 
     */
    authSecurityCode(width) {
        if (isNaN(width)) {
            return;
        }
        this.loading = true;
        let params = { Xpos: width, Ypos: this.height, CatchId: this.catchId }
        this.signinService.authSecurityCode(params).then(res => {
            if (res.Result) {
                this.loading = false;
                this.authSuccess = true
                // document.body.removeEventListener('mousemove', (ev) => { ev.preventDefault() }, false);
                // this.slide.removeEventListener('mousedown', (ev) => { ev.preventDefault() }, false);
                // this.slide.removeEventListener('mouseup', (ev) => { ev.preventDefault() }, false);
                this.slide.removeEventListener('touchstart', (ev) => { ev.preventDefault() }, false);
                document.body.removeEventListener('touchmove', (ev) => { ev.preventDefault() }, false);
                this.slide.removeEventListener('touchend', (ev) => { ev.preventDefault() }, false);
                this.dismiss({ slideWidth: width, authSuccess: true, catchId: this.catchId });
            } else {
                this.loading = false;
                this.authSuccess = true;
                this.alert.shownewAlert('验证失败，请再次验证', '验证', false, () => {
                    this.authSuccess = false;
                    this.getSecurityCode();
                });
            }
        }).catch(err => {
            this.loading = false;
        })

    }

    /** 获取验证图片 */
    // needSecurityCode() {
    //     this.left = 0;
    //     if (this.authSuccess) {
    //         return;
    //     }
    //     this.loading = true;
    //     const params = `username=${this.userName}&v=2`;
    //     return this.signinService.needSecurityCode(this.catchId).then((res: any) => {
    //         this.loading = false;
    //         if (res.error == 0) {
    //             this.imageObj = res.data;
    //             this.setImageUrl();
    //         }
    //     }).catch(e => {
    //         this.loading = false;
    //     });
    // }


    /** 获取验证图片 */
    getSecurityCode() {
        this.left = 0;
        if (this.authSuccess) {
            return;
        }
        this.loading = true;
        return this.signinService.getSecurityCode(this.catchId).then((res: any) => {
            this.loading = false;
            if (res) {
                this.imageObj = res;
                this.setImageUrl();
            }
        }).catch(e => {
            this.loading = false;
        });
    }

    setImageUrl() {
        const _originalImg = `data:image/png;base64,${this.imageObj.BackImage}`;
        const _sliderImgUrl = `data:image/png;base64,${this.imageObj.SlidingImage}`;
        this.originalImg = this.sanitizer.bypassSecurityTrustResourceUrl(_originalImg);
        this.slideImg = this.sanitizer.bypassSecurityTrustResourceUrl(_sliderImgUrl);
        this.height = this.imageObj.yHeight;
    }


    move(event) {
        var touch;
        if (event.touches) {
            touch = event.touches[0];
        } else {
            touch = event;
        }
        let left = touch.clientX - this.originalX
        this.left = left < 0 ? 0 : left > 240 ? 240 : left;
        this.left = parseInt(this.left.toString().split('.')[0]);
    }

    down(event) {
        var touch;
        if (event.touches) {
            touch = event.touches[0];
        } else {
            touch = event;
        }
        // 记录原始坐标
        this.originalX = touch.clientX;
    }


    dismiss(data?) {
        if (data) {
            this.viewCtrl.dismiss(data);
        } else {
            this.viewCtrl.dismiss();
        }
    }
}

class ImageModel {
    SlidingImage: string;
    needSecurityCode: string;
    BackImage: string;
    yHeight: any;
    constructor() {
        this.SlidingImage = '';
        this.needSecurityCode = '';
        this.BackImage = '';
        this.yHeight = '';
    }
}


// WEBPACK FOOTER //
// ./src/pages/signin/slide-block/slideBlock.ts